<template>
    <span
        class="w-full flex items-center rounded border p-1"
        :class="isActive ? 'bg-primary/20 border-primary/70' : 'bg-primary/10 border-base-300'"
        :title="document.filename"
        @mouseenter="emit('hover')"
    >
        <span class="flex items-center w-full gap-1">
            <span class="flex gap-x-1 bg-default/90 transition-colors duration-200 hover:bg-primary/30 rounded border border-gray-300 px-1" @click.prevent="emit('click')">
                <UIcon name="i-ph-eye" class="size-5"/>
                <span>Vis</span>
            </span>

            <span class="w-10/12 truncate text-ellipsis overflow-hidden whitespace-nowrap flex">
                <span>{{ document.filename }}</span>
            </span>

            <Button
                class="i-mdi-close hover:text-red-500 pointer-cursor min-w-[32px] text-xl transition-colors"
                title="Fjern fil"
                @click.stop.prevent="emit('remove')"
            />
        </span>
    </span>
</template>

<script setup lang="ts">

defineProps({
    document: {
        type: Object,
        required: true
    },
    isActive: {
        type: Boolean,
        default: false
    },
    hasUrl: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['click', 'hover', 'remove'])

</script>

<style scoped>

</style>